export const ROLES = {
  PLATFORM_ADMIN: "platform_admin",
  TENANT_ADMIN: "tenant_admin",
  SUPPORT_AGENT: "support_agent",
  VIEWER: "viewer",
};

// Kept for display compatibility only. Access is determined exclusively by
// the server-issued permissions and protected administrator flags.
export const resolveRole = (role) => ({ 0: ROLES.PLATFORM_ADMIN, 1: ROLES.TENANT_ADMIN, 2: ROLES.SUPPORT_AGENT }[role] || null);

export const isPlatformAdmin = (user) => user?.is_super_admin === true;
export const membershipFor = (user, clientId = user?.client_id) => clientId == null ? null
  : user?.memberships?.find((membership) => String(membership.client_id) === String(clientId)
    && membership.active !== false && !membership.deleted);
export const isClientAdmin = (user, clientId = user?.client_id) => (
  isPlatformAdmin(user) || membershipFor(user, clientId)?.is_client_admin === true
);
export const canManageClientAccess = isClientAdmin;
export const hasEffectivePermissions = (user, clientId = user?.client_id) => (
  isClientAdmin(user, clientId)
  || membershipFor(user, clientId)?.permissions?.some((permission) => (
    typeof permission === "string" && permission !== "*" && permission.includes(".")
  )) === true
);

export function can(user, permission, clientId = user?.client_id) {
  if (!user || typeof permission !== "string" || !permission.includes(".")) return false;
  if (isPlatformAdmin(user)) return true;
  const membership = membershipFor(user, clientId);
  if (!membership) return false;
  if (membership.is_client_admin === true) return true;
  return Array.isArray(membership.permissions)
    && membership.permissions.includes(permission);
}

export const isTenantAdmin = (user) => isClientAdmin(user);
export const isSupportAgent = () => false;
export const isViewer = () => false;
export const canAccessWorkspace = (user) => hasEffectivePermissions(user);
export const canManagePlatform = isPlatformAdmin;
export const canManageTenant = isClientAdmin;
export const canViewTenant = (user, clientId) => hasEffectivePermissions(user, clientId);
export const isReadOnly = (user) => !can(user, "customers.update");
export const canManageAllTenants = isPlatformAdmin;
export const canWriteInTenant = canManageTenant;
export const canCreateTenant = isPlatformAdmin;
export const canAccessAdminConsole = canAccessWorkspace;
export const canAccessTenantAdminScreens = canAccessWorkspace;
export const canAccessOrgManagement = isPlatformAdmin;
export const getAccessDeniedMessage = () => "You do not have access to this area.";
